
const BASE_URL = 'https://appp.cryprtorq.com.ng/public/api';
//const BASE_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000/api"; 
//const BASE_URL =  "http://127.0.0.1:8000/api"; 
export default BASE_URL;

//export const BASE_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000/api";


// const BASE_URL =
//   process.env.REACT_APP_API_URL || "http://127.0.0.1:8000/api";

// export default BASE_URL;
